'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-trailing-spaces */
var URL_REG = new RegExp('^([a-z0-9-]+\:)?' + //protocol
'[/]{2}' + //slash x 2
'(?:([^@/:\?]+)(?::([^@/:]+))?@)?' + //username:password@
'([^:/?#]+)' + //hostname
'(?:[:]([0-9]+))?' + //port
'([/][^?#;]*)?' + //pathname
'(?:[?]([^#]*))?' + //search
'([#][^?]*)?$' //hash
, 'i');
/* eslint-enable no-trailing-spaces */

var HttpURL = function () {
    function HttpURL(url) {
        _classCallCheck(this, HttpURL);

        this._params = {};
        this._hash = '';
        if (url) {
            this.assign(url.toString());
        }
    }

    _createClass(HttpURL, [{
        key: 'assign',
        value: function assign(v) {
            v = v || '';
            var matches = v.match(URL_REG);

            if (matches) {
                this.protocol = matches[1] || ((typeof location === 'undefined' ? 'undefined' : _typeof(location)) === 'object' ? location.protocol : '');

                this.username = matches[2] || '';

                this.password = matches[3] || '';

                this.hostname = matches[4];

                this.port = matches[5] || '';

                this.pathname = matches[6] || '/';

                this.search = matches[7] || '';

                this.hash = matches[8] || '';

                this.origin = this.protocol + '//' + this.host;
            } else {
                throw new Error('Parse Error');
            }
        }
    }, {
        key: 'toString',
        value: function toString() {
            var string = this.protocol + '//';
            if (this.username) {
                string += this.username;
                if (this.password) {
                    string += ':' + this.password;
                }
                string += '@';
            }
            string += this.hostname;
            if (this.port && this.port !== '80') {
                string += ':' + this.port;
            }
            if (this.pathname) {
                string += this.pathname;
            }
            if (this.search) {
                string += this.search;
            }
            if (this.hash) {
                string += this.hash;
            }
            return string;
        }
    }, {
        key: 'params',
        get: function get() {
            return this._params;
        },
        set: function set(v) {
            if (!!v && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && !(v instanceof Date) && !(v instanceof RegExp) && !(v instanceof Array) && !(v instanceof String) && !(v instanceof Number) && !(v instanceof Boolean)) {
                for (var p in this._params) {
                    delete this._params[p];
                }
                for (var p in v) {
                    this._params[p] = v[p];
                }
            }
        }
    }, {
        key: 'search',
        get: function get() {
            var search = [];
            for (var p in this._params) {
                if (this._params[p] === undefined) {
                    continue;
                }
                if (this._params[p] !== '') {
                    try {
                        search.push(encodeURIComponent(p) + '=' + encodeURIComponent(this._params[p]));
                    } catch (e) {
                        /* istanbul ignore next */
                        search.push(p + '=' + this._params[p]);
                    }
                } else {
                    try {
                        search.push(encodeURIComponent(p));
                    } catch (e) {
                        /* istanbul ignore next */
                        search.push(p);
                    }
                }
            }
            if (search.length) {
                return '?' + search.join('&');
            } else {
                return '';
            }
        },
        set: function set(v) {
            if (typeof v === 'string' || v instanceof String) {
                v = v.toString();

                if (v.indexOf('?') === 0) {
                    v = v.substr(1);
                }
                var search = v.split('&');
                for (var p in this._params) {
                    delete this._params[p];
                }
                for (var i = 0; i < search.length; i++) {
                    var _search$i$split = search[i].split('=');

                    var _search$i$split2 = _slicedToArray(_search$i$split, 2);

                    var key = _search$i$split2[0];
                    var value = _search$i$split2[1];
                    // value 可能为 0/false/null 等非空但直接运算会返回 false 的值

                    if (value !== undefined) {
                        value = value.toString();
                    }
                    if (key) {
                        try {
                            this._params[decodeURIComponent(key)] = decodeURIComponent(value);
                        } catch (e) {
                            /* istanbul ignore next */
                            this._params[key] = value;
                        }
                    }
                }
            }
        }
    }, {
        key: 'hash',
        get: function get() {
            return this._hash;
        },
        set: function set(v) {
            if (typeof v === 'string' || v instanceof String) {
                v = v.toString();

                if (v && v.indexOf('#') < 0) {
                    v = '#' + v;
                }
                this._hash = v || '';
            }
        }
    }, {
        key: 'host',
        get: function get() {
            return this.hostname + (this.port ? ':' + this.port : '');
        },
        set: function set(v) {
            if (typeof v === 'string' || v instanceof String) {
                v = v.toString();

                var matches = v.match(/([^:/?#]+)(?:[:]([0-9]+))?/);

                if (matches) {
                    this.hostname = matches[1];
                    this.port = matches[2] || '';
                }
            }
        }
    }]);

    return HttpURL;
}();

exports.default = HttpURL;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_lib-httpurl@2.0.2@@ali/lib-httpurl/src/index.js
// module id = 30
// module chunks = 0